// extracted by mini-css-extract-plugin
export default {"header":"FiltersHeader_header__4ZuuN"};